import './Markers.css';

export function TachoRestSvgData(width: number, height: number, fillColor: string) {
  return `
   <svg class="idata-target-marker" width="${width}" height="${height}" viewBox="-2 -2 28 28" fill="${fillColor}" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.70732 9.98913H21V23H17.2927V13.6413H5.70732V23H2V2H5.70732V9.98913Z"/>
   </svg>`;
}
